<template>
  <div>
    <div class="plan-container plan-container__summary">
      <p class="title">8. Summary</p>
      <p class="subtitle">
        Based on your selections, the overall grade of the plan is
        <span class="grading-result" :class="`graded-${finalGrading}`">{{
          grading
        }}</span>
      </p>
      <div class="plan-list">
        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>Theme</th>
                <th>Your grading</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(section, index) in allSections"
                :key="section.id"
                :ref="section.id"
                :class="{ 'is-duped': section.duped }"
                v-on:click="() => showSectionModal(section)"
              >
                <td>{{ sectionName(section.name, index) }}</td>
                <td>
                  {{
                    section.id === 'next-steps'
                      ? nextSteps
                      : determination(section)
                  }}
                </td>
                <td><span class="colour-code"></span></td>
              </tr>
            </tbody>
          </table>
          <p class="disclaimer">
            *If essential criteria theme is highlighted above, this identifies
            that some of the key information is missing. This audit can still be
            submitted but it would be advisable to inform the SEN team and
            relevant SEN case officer of this omission.
            <br />
            **Please note, the following do not impact the final grading of the
            audit: any themes identified as ‘Not Applicable’ and the ‘Key
            Requirements’ and ‘Additional Components’ themes.
          </p>
          <p class="warning" v-if="duped.show">
            Some themes are duplicated. Please click on highlighted themes,
            review their summaries and select a final version.
          </p>
        </div>
        <div class="info-row">
          <p class="link link--back">
            <!-- <i class="fas fa-chevron-circle-left"></i>
            <a @click="$router.go(-1)">Back</a> -->
          </p>
        </div>
        <div class="info-row info-row--right">
          <p class="link" :class="{ disabled: !hasPassedChecks || duped.show }">
            <a @click="submitFinal">Submit</a>
            <i class="fas fa-chevron-circle-right"></i>
          </p>
        </div>
      </div>
    </div>

    <div class="modal modal-large" :class="{ 'is-active': sectionModal.show }">
      <div class="modal-background" @click.stop="hideSectionModal"></div>
      <div v-if="sectionModal.show" class="modal-content">
        <div class="title">
          theme {{ sectionModal.section.id.toUpperCase() }} Summary -
          <small>{{
            criteriaNames[sectionModal.section.determination].text
          }}</small>
        </div>
        <hr />

        <div v-if="sectionModal.section.comments" class="padded">
          <h3>Comments</h3>
          <p>{{ sectionModal.section.comments }}</p>
        </div>

        <div
          v-for="criterion in Object.keys(sectionModal.section.criteria)"
          :key="criterion"
          class="padded"
        >
          <div v-if="sectionModal.section.criteria[criterion].length">
            <h3>{{ criteriaNames[criterion].text }}</h3>
            <ul>
              <li
                v-for="choice of sectionModal.section.criteria[criterion]"
                :key="choice"
              >
                {{ choice }}
              </li>
            </ul>
          </div>
        </div>

        <div class="text-right">
          <button
            v-if="duped.dupes.includes(sectionModal.section.id)"
            v-on:click="submitDedupe()"
            v-bind:disabled="sectionModal.loading"
            class="button is-gradient"
          >
            Use as final theme {{ sectionModal.section.id.toUpperCase() }}
          </button>
          <button v-on:click="hideSectionModal" class="button secondary">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { displaySuccess, displayWarning } from '@/utils/notification-factory'
import { message } from '@/utils/app-messages'
import { gradableSections } from '@/utils/audit'

export default {
  name: 'AuditSummary',
  data() {
    return {
      tmpResult: 'requires_improvement',
      sectionModal: {
        show: false,
        loading: false,
        section: {}
      },
      criteriaNames: {
        not_applicable: {
          text: 'Not Applicable'
        },
        outstanding: {
          text: 'Outstanding'
        },
        good: {
          text: 'Good'
        },
        requires_improvement: {
          text: 'Requires Improvement'
        },
        inadequate: {
          text: 'Inadequate'
        },
        essential: {
          text: 'Clearly Includes'
        },
        incomplete: {
          text: 'Incomplete'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      sections: 'audit/sections',
      currentPlanId: 'plan/currentPlanId',
      finalGrading: 'audit/finalGrading'
    }),
    sectionGrading() {
      return this.section.id === 'additional-components'
        ? this.additionalComponents
        : this.section.id === 'next-steps'
          ? this.nextSteps
          : this.section.determination
    },
    grading() {
      this.checkFinalGrading()
      return this.finalGrading
        .toUpperCase()
        .split('_')
        .join(' ')
    },
    // additionalComponents() {
    //   const additionalComponents = this.sections.find(
    //     s => s.id === 'additional-components'
    //   )
    //   const total = additionalComponents.criteria.optional.length
    //   return `${total} / 3`
    // },
    nextSteps() {
      const nextSteps = this.sections.find(s => s.id === 'next-steps')
      return nextSteps ? nextSteps.criteria.optional.length : 0
    },
    hasPassedChecks() {
      const findEveryIndex = (sec) => {
        return this.sortedSections.findIndex(({ id }) => id === sec) !== -1
      }
      const isEverySection = !gradableSections.every(findEveryIndex)

      console.log({ isEverySection })

      if (isEverySection) {
        return false
      }

      const sortedSectionFilter = (section) => {
        console.log(section)
        return section.determination === 'Section Incomplete'
      }

      const incomplete = this.sortedSections.filter(sortedSectionFilter)

      console.log({ incomplete })

      if (incomplete.length > 1) {
        return false
      }

      return true
    },
    sortedSections() {
      console.log('sections', this.sections)
      const firstPass = this.sections.slice()
      const secondPass = firstPass.sort((a, b) => (a.id < b.id ? -1 : 1))

      // const additional = secondPass.filter(s => s.id === 'next-steps')
      // const additionalComponents = secondPass.filter(
      //   s => s.id === 'additional-components'
      // )
      // const onlySections = secondPass.filter(
      //   s => s.id !== 'additional-components' && s.id !== 'next-steps'
      // )
      // console.log({ onlySections, additionalComponents })
      // return [...onlySections, ...additionalComponents]
      const onlySections = secondPass.filter((s) => {
        return s.id !== 'next-steps'
      })

      console.log('onlySection', [...onlySections])

      return [...onlySections]
    },
    allSections() {
      const order = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'next-steps'
      ]
      console.log(this.sections.map(({ id }) => console.log(id)))

      const allSections = this.sections
        .map(s => {
          // Check for dupes.
          return { ...s, duped: this.duped.dupes.includes(s.id) }
        })
        .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))

      console.log({ allSections })

      return allSections
    },
    duped() {
      const dupes = []

      // Find each theme that has been duped and add it to the dupes list.
      this.sections.forEach(outerSection => {
        this.sections.filter(
          innerSection => outerSection.id === innerSection.id
        ).length > 1 &&
          !dupes.includes(outerSection.id) &&
          dupes.push(outerSection.id)
      })

      return {
        show: dupes.length >= 1 || false,
        dupes: dupes || []
      }
    }
  },
  methods: {
    ...mapActions({
      setAuditComplete: 'audit/completedAudit',
      dedupeSection: 'audit/dedupeSection'
    }),
    ...mapMutations({ checkFinalGrading: 'audit/CHECK_GRADING' }),
    determination(section) {
      if (section.determination === 'Section Incomplete') {
        return this.criteriaNames.incomplete && this.criteriaNames.incomplete.text
      }

      return this.criteriaNames[section.determination] && this.criteriaNames[section.determination].text
    },
    formatOutcome(val) {
      console.log({ val })
      return val !== undefined || val !== null
        ? val.split('_').join(' ')
        : 'Not Applicable'
    },
    async submitFinal() {
      try {
        await this.setAuditComplete()
        displaySuccess(message.COMPLETED_AUDIT_SUCCESSFULLY)
        this.$router.push('/plans/select')
      } catch (err) {
        displayWarning(message.FAILED_TO_SAVE_ASSESSMENT)
        console.log({ err })
      }
    },
    async submitDedupe() {
      this.sectionModal.loading = true
      await this.dedupeSection({ ...this.sectionModal.theme })
      this.checkFinalGrading()
      this.hideSectionModal()
      this.sectionModal.loading = false
    },
    showSectionModal(section) {
      this.sectionModal.theme = section
      this.sectionModal.show = true
    },
    hideSectionModal(section) {
      this.sectionModal.theme = {}
      this.sectionModal.show = false
    },
    sectionName(name, index) {
      if (!name) return index

      console.log(name, index)

      // remove the first character from name if it's a number (e.g. 1) and replace with index
      const idName = name.replace(/^\d/, index + 1)

      return idName
    }
  },
  mounted() {
    if (!this.sections.length) {
      this.$router.push('/plans/select')
    }

    this.checkFinalGrading()
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/components.scss';
@import '@/style/sections.scss';
@import '@/style/modal.scss';

.grading-result {
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: 600;
}

.disclaimer {
  padding-left: $padding1x;
  padding-top: $padding1x;
  font-weight: 500;
}

.warning {
  margin-top: 16px;
  padding: 1rem;
  background: #fff1f1;
  border-radius: 15px;
}

.colour-code {
  height: 30px;
  width: 30px;
  border-radius: 15px;
}

p.link a {
  padding-bottom: 1rem;
}

.is-failed {
  background: '#E76D93';
}

.is-duped {
  background: #fff1f1;
}

table tr.is-duped:nth-child(even) {
  background: #fbeaea;
}

.graded-outstanding {
  color: $outstanding-color;
}

.graded-good {
  color: $good-color;
}

.graded-requires_improvement {
  color: $ri-color;
}

.graded-inadequate {
  color: $inadequate-color;
}

.modal-content .padded {
  padding: 0.5rem 1rem;
}
</style>
